import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/home/home-start.svg",
  class: "w-6 pt-1 pb-[2px]"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("INÍCIO")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/home/home-das.svg",
  class: "w-6 pt-1 pb-[2px]"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("DAS")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/home/home-services.svg",
  class: "w-6 pt-1 pb-[2px]"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("SERVIÇOS")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/home/home-dasn.svg",
  class: "w-6 pt-1 pb-[2px]"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("DASN")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/home/home-solutions.svg",
  class: "w-6 pt-1 pb-[2px]"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("SOLUÇÕES")

import { ref, onMounted } from "vue";
import { Device } from "@capacitor/device";
import { StatusBar, Style } from "@capacitor/status-bar";
import { isPlatform } from "@ionic/vue";
import {
	IonTabBar,
	IonTabButton,
	IonTabs,
	IonLabel,
	IonPage,
	IonRouterOutlet,
	toastController,
	IonContent,
	useIonRouter,
	onIonViewWillEnter,
} from "@ionic/vue";

import LoadingScreen from "@/components/LoadingScreen.vue";
import SideMenu from "@/components/SideMenu.vue";

import api from "@/services/api/api";
import { useUser } from "@/composables/user";
import { useStory } from "@/composables/stories";
import { usePushNotification } from "@/composables/pushNotification";

import { AFInit } from "appsflyer-capacitor-plugin";
import { AppsFlyer } from "appsflyer-capacitor-plugin";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const ionRouter = useIonRouter();
const {
	registerNotifications,
	onRegistration,
	onPushNotificationActionPerformed,
} = usePushNotification();
const { openStory } = useStory();
const { loadUser, logout } = useUser();

const loading = ref(false);

const handleMountedDashboard = async () => {
	StatusBar.setBackgroundColor({ color: "#102763" });
	StatusBar.setStyle({ style: Style.Dark });
	try {
		loading.value = true;

		await loadUser();

		loading.value = false;
	} catch (error: any) {
		const toast = await toastController.create({
			message: error.message,
			duration: 2000,
			color: "danger",
		});

		await toast.present();
		await logout();

		ionRouter.navigate("/login", "none", "replace");
	}
};

const handlePushNotificationRegistration = async (token: string) => {
	const { model, osVersion, name, platform, operatingSystem, manufacturer } =
		await Device.getInfo();

	await api
		.sendPushNotificationToken({
			token,
			device: {
				model,
				osVersion,
				name,
				platform,
				operatingSystem,
				manufacturer,
			},
		})
		.catch(() => null);
};

onPushNotificationActionPerformed(({ notification }) => {
	if (
		notification.data.redirectToNotifications &&
		notification.data.notificationId
	) {
		console.log(
			"Redirecting to notifications",
			notification.data.notificationId
		);
	}
	//
});

onRegistration((token: string) => handlePushNotificationRegistration(token));

const initAppsFlyer = async () => {
	const afConfig: AFInit = {
		appID: "com.gerenciamei",
		devKey: "SYf6qmZd4nYS9icZdQkFvA",
		isDebug: false,
		registerConversionListener: true,
		registerOnDeepLink: true,
		waitForATTUserAuthorization: 10,
	};

	if (isPlatform("ios")) {
		afConfig.appID = "6444381743";
	}

	AppsFlyer.initSDK(afConfig)
		.then((res) => {
			// alert(JSON.stringify(afConfig));
			console.log(JSON.stringify(res));
		})
		.catch((error) => console.log(JSON.stringify(error)));
};

const loadData = async () => {
	initAppsFlyer();
};

onIonViewWillEnter(() => {
	handleMountedDashboard();
});

onMounted(() => {
	registerNotifications().catch(console.error);
	loadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(LoadingScreen)
        ]),
        _: 1
      }, 512), [
        [_vShow, loading.value]
      ]),
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(SideMenu),
          _createVNode(_unref(IonTabs), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRouterOutlet)),
              (!_unref(openStory))
                ? (_openBlock(), _createBlock(_unref(IonTabBar), {
                    key: 0,
                    slot: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTabButton), {
                        tab: "home",
                        href: "/home"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonTabButton), {
                        tab: "das",
                        href: "/das"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonTabButton), {
                        tab: "services",
                        href: "/services",
                        class: "cta-button bg-green-500"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonTabButton), {
                        tab: "d-dasn",
                        href: "/d-dasn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonTabButton), {
                        tab: "solutions",
                        href: "/solutions"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, !loading.value]
      ])
    ]),
    _: 1
  }))
}
}

})